import useStyles from "../styles";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import OrganizationChart from "@dabeng/react-orgchart";
import MyNode from "../../../components/OrgNode";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import SelectGroup from "../../../components/FormComponent/SelectGroup";

const AdminOrganogram = () => {
  const [currentOrg, setCurrentOrg] = useState({});
  const [reassignModal, setReassignModal] = useState(false);
  const [allEmployees, setAllEmployees] = useState([]);
  const [firstSelected, setFirstSelected] = useState("");
  const [secondSelected, setSecondSelected] = useState("");
  const [reportEmployee, setReportEmployee] = useState([]);
  const [supervisorEmployees, setSupervisorEmployees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const ORGANOGRAM_ENDPOINT = "/api/v1/organogram";
  const SUPERVISE_ENDPOINT = "/api/v1/supervision";
  const EMPLOYEES_ENDPOINT = "/api/v1/employees";
  const classes = useStyles();

  const getCompanyOrganogram = () => {
    httprequest.get(ORGANOGRAM_ENDPOINT)
      .then((res) => {
        setCurrentOrg(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.message || "Failed to fetch organogram");
      });
  };

  const handleReassignModal = () => {
    setReassignModal(!reassignModal);
  };

  const closeReassignModal = () => {
    setReassignModal(false);
    setFirstSelected("");
    setSecondSelected("");
  };

  const fetchAllEmployees = () => {
    httprequest.get(EMPLOYEES_ENDPOINT)
      .then((res) => {
        setAllEmployees(res?.data?.data?.employees || []);
        setSupervisorEmployees(res?.data?.data?.employees || []);
        setReportEmployee(res?.data?.data?.employees || []);
      })
      .catch((err) => {
        toast.error(err?.response?.data || "Failed to fetch employees");
      });
  };

  const handleReassign = () => {
    if (!firstSelected || !secondSelected) {
      toast.error("Please select both employees");

      return;
    }

    setIsLoading(true);
    httprequest.patch(`${SUPERVISE_ENDPOINT}/${secondSelected}`, { memberId: firstSelected })
      .then((res) => {
        setIsLoading(false);
        toast.success(res?.data?.message || "Reassignment successful");
        closeReassignModal();
        getCompanyOrganogram();
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data.message || "Failed to reassign employee");
      });
  };

  useEffect(() => {
    getCompanyOrganogram();
    fetchAllEmployees();
  }, []);

  const handleSelectOne = (e) => {
    const { value } = e.target;
    setFirstSelected(value);

    const nonSelected = allEmployees.filter((employee) => employee?.employee_id !== value);
    setSupervisorEmployees(nonSelected);
  };

  const handleSelectTwo = (e) => {
    const { value } = e.target;
    setSecondSelected(value);

    const nonSelected = allEmployees.filter((employee) => employee?.employee_id !== value);
    setReportEmployee(nonSelected);
  };

  return (
    <Grid container spacing={4}>
      <Grid item lg={3} md={4} sm={12} xs={12}>
        <div className="left-container">
          <h4>Personal Information</h4>
          <h6>Update your personal details here</h6>
          <div className={classes.downloadbutton}>
            <Button variant="primary" color="btndefault" buttonSize="full" buttonName="Reassign Staff" onClick={handleReassignModal} />
          </div>
        </div>
      </Grid>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <div className="right-container">
          <OrganizationChart
            datasource={currentOrg}
            chartClass="myChart"
            NodeTemplate={MyNode}
            pan={true}
          />
        </div>
      </Grid>
      <Modal
        title="Reassign Employee"
        subtitle="Reassign who reports to another in the organisation"
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup label="Select Employee">
                  <select onChange={handleSelectOne} value={firstSelected}>
                    <option value="">--Select Employee --</option>
                    {reportEmployee?.map((employee, i) => (
                      <option key={i} value={employee?.employee_id}>{`${employee?.first_name} ${employee?.last_name}`}</option>
                    ))}
                  </select>
                </SelectGroup>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup label="Reassign To">
                  <select onChange={handleSelectTwo} value={secondSelected}>
                    <option value="">--Select Employee --</option>
                    <option value="">Admin (Me)</option>
                    {supervisorEmployees?.map((employee, i) => (
                      <option key={i} value={employee?.user_id}>{`${employee?.first_name} ${employee?.last_name}`}</option>
                    ))}
                  </select>
                </SelectGroup>
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <Button variant="primary" buttonName="Reassign Employee" buttonSize="full" color="btndefault" onClick={handleReassign} isLoading={isLoading} />
          </>
        }
        isopen={reassignModal}
        closeModal={closeReassignModal}
      />
      {/* <ToastContainer /> */}
    </Grid>
  );
};

export default AdminOrganogram;
